<form [formGroup]="formGroup">
  <div fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" class="mb-3">
      <mat-form-field fxFlex>
        <mat-label>
          {{ 'service-review-inquiry.form.start-date.label' | translate }}
        </mat-label>
        <mmx-date-selector-input formControlName="fromDate"></mmx-date-selector-input>
        <mat-hint>{{ 'service-review-inquiry.form.start-date.hint' | translate }}</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex>
        <mat-label>
          {{ 'service-review-inquiry.form.end-date' | translate }}
        </mat-label>
        <mmx-date-selector-input formControlName="toDate"></mmx-date-selector-input>
      </mat-form-field>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" class="mb-3">
      <mat-form-field fxFlex>
        <mat-label>
          {{ 'service-review-inquiry.form.certification-date.label' | translate }}
        </mat-label>
        <mmx-date-selector-input formControlName="certificationIssueDate"></mmx-date-selector-input>
        <mat-hint>{{ 'service-review-inquiry.form.certification-date.hint' | translate }}</mat-hint>
      </mat-form-field>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
      <mat-form-field *ngIf="type === 'authorizations'" fxFlex>
        <mat-label>
          {{ 'service-review-inquiry.form.reference-number.label' | translate }}
        </mat-label>
        <input matInput formControlName="referenceNumber">
        <mat-hint>{{ 'service-review-inquiry.form.reference-number.hint' | translate }}</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex>
        <mat-label>
          {{ 'service-review-inquiry.form.certification-number.label' | translate }}
        </mat-label>
        <input matInput formControlName="certificationNumber" pattern="^[a-zA-Z0-9]{1,50}$" maxlength="50">
        <mat-hint>{{ 'service-review-inquiry.form.certification-number.hint' | translate }}</mat-hint>
      </mat-form-field>
    </div>
  </div>
</form>
